// extracted by mini-css-extract-plugin
export var productImage = "_l9-1";
export var viewLink = "_l9-2";
export var wishlistItem = "_l9-0";